import { createSlice } from '@reduxjs/toolkit'
import { get } from 'lodash';

const initialQuestionState = {
  question_english: '',
  question_hindi: '',
  option: [],
  entry_fee: null,
  pred_confirm: false,
  pred_autocreate: false,
  predic_start_time: null,
  predic_end_time: null,
  slots: 10,
  inputAnswerNumber: null,
  admin_commission: 10,
  slots_per_user: 2
};

export const predictionSlice = createSlice({
  name: 'prediction',
  initialState: {
    question: [],
    modal_show: false,
    questionStates: initialQuestionState,
    isSubjective: false,
    isGlobal:false,
    globalList:[]
  },
  reducers: {
    addQuestion: (state, action) => {
      state.question = [...action.payload]
    },
    stateRefresh: (state, action) => {
      state.questionStates = initialQuestionState
      state.isEdit =false
      state.isAdd=true
    },
    modalToggle: (state, action) => {
      state.modal_show = !state.modal_show;
      state.questionStates = initialQuestionState;
      if (get(action,'payload.isSubjective', false) && state.modal_show) {
        state.isGlobal = false
        state.isSubjective = action.payload.isSubjective
        state.isSuisGlobalbjective = action.payload.isGlobal
      }else if(get(action,'payload.isGlobal', false) && state.modal_show){
        state.isSubjective =false
        state.isGlobal = action.payload.isGlobal
      }else if(state.modal_show){
        state.isSubjective = false
        state.isGlobal = false
        state.questionStates["slots"] = 1000
        state.questionStates["slots_per_user"] = 100
      }
    },
    stateValues: (state, action) => {
      state.questionStates[action.payload.name] = action.payload.value
    },
    setEditQuestion: (state, action) => {
      state.questionStates = action.payload
    },
    setGlobalList:(state,action) => {
      state.globalList = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { addQuestion, modalToggle, stateValues, setEditQuestion,setGlobalList, stateRefresh } = predictionSlice.actions

export default predictionSlice.reducer